import { Children, isValidElement } from 'react'
import {
  DatagridHeader as MuiDatagridHeader,
  DatagridHeaderProps
} from 'react-admin'
import { TableCell } from '@mui/material'

interface Props extends DatagridHeaderProps {
  hideColumns?: string[]
}

const DatagridHeader = (props: Props) => {
  const { children, hideColumns, ...rest } = props

  const filteredChildren = Children.map(children, (child) => {
    if (isValidElement(child) && hideColumns?.includes(child.props.label)) {
      return <TableCell />
    }

    return child
  })

  return <MuiDatagridHeader {...rest}>{filteredChildren}</MuiDatagridHeader>
}

export default DatagridHeader
